// @flow
import React from 'react';
import { TextField } from '@src/formik-utils/FormFields';
import { SP_USER_COMMIT_DETAILS_CONFIG_MAP } from '@streaming-projects/user-commit-details/config';
import { BACKEND_FIELDNAMES } from '@streaming-projects/enums';

export const SPUserCommitQuoteNameContainer = () => {
  const quoteNameConfig = SP_USER_COMMIT_DETAILS_CONFIG_MAP.get(BACKEND_FIELDNAMES.SFDC_QUOTE_NAME);
  const { displayName, backendFieldName } = quoteNameConfig;

  return <TextField fieldDisplayName={displayName} fieldName={backendFieldName} />;
};
